var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "dialogText",
        light: "",
        persistent: "",
        "max-width": "700",
      },
      model: {
        value: _vm.isDialog,
        callback: function ($$v) {
          _vm.isDialog = $$v
        },
        expression: "isDialog",
      },
    },
    [
      _vm.isDialog
        ? _c("v-card", [
            _c(
              "div",
              {
                staticClass: "absX",
                on: {
                  "&click": function ($event) {
                    return _vm.closeDialog.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "v-icon",
                  { staticClass: "myGray", attrs: { "x-large": "" } },
                  [_vm._v("mdi-window-close")]
                ),
              ],
              1
            ),
            _c("div", { staticClass: "pa-5 thisDialog text-center" }, [
              _c("h3", { staticClass: "mb-5" }, [
                _vm._v("Wähle ein Bestellmodus:"),
              ]),
              _c("div", { staticClass: "d-flex align-center justify-center" }, [
                _c(
                  "div",
                  { staticClass: "mobile pa-3" },
                  [
                    _c("OrderModeSwitcher", {
                      on: { selected: _vm.closeDialog },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "tablet pl-2 pr-2 pt-4 pb-7" },
                  [
                    _c("OrderModeSwitcher", {
                      on: { selected: _vm.closeDialog },
                    }),
                  ],
                  1
                ),
              ]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }